




































































import { Component, Vue } from 'vue-property-decorator';
import { changeLoading } from '@/util/plugins';
const MAX_LENGTH = 3;
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  get_list: `${FCAPI}/shang/ruan/style`,
  add_style: `${FCAPI}/shang/ruan/style`,
  edit: `${FCAPI}/shang/ruan/style/`,
  get_detail: `${FCAPI}/shang/ruan/style/`,
};
const getUrl = require('baimahu/url-with-param');
function initStyleList(remote?: any) {
  remote = remote || {};
  return {
    current: remote.current || 0,
    detail: remote.detail || [],
    last: remote.last || 0,
    limit: remote.limit || 0,
    total: remote.total || 0,
  };
}
@Component
export default class StyleList extends Vue {
  is_loading: boolean = false;
  is_show_add_modal: boolean = false;
  add_style_name: string = '';
  style_list: any = initStyleList();
  active_index: number = -1;
  old_value: string = '';
  is_edit: boolean = false;
  edit_style_id: number = 0;
  get maxLength() {
    return MAX_LENGTH;
  }

  paginationOption(data: any) {
    return {
      showTotal: () => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 0,
      total: data.total || 0,
      current: data.current || 0,
    };
  }

  // 关闭模态窗
  closeModal() {
    this.is_show_add_modal = false;
    this.add_style_name = '';
  }

  // 关闭修改排序输入框
  closeInput(record: any) {
    this.active_index = -1;
    record.sort = this.old_value;
    this.old_value = '';
  }

  // 展示修改排序输入框
  showInput(index: number, record: any) {
    this.active_index = index;
    this.old_value = record.sort;
  }

  // 点击编辑按钮
  @changeLoading(['is_loading'])
  async editStyle(record: any) {
    this.is_show_add_modal = true;
    this.is_edit = true;
    const res = await this.$axios.get(`${API.get_detail}${record.id}/edit?id=${record.id}`);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.add_style_name = res.data.data.name;
    this.edit_style_id = res.data.data.id;
  }

  // 切换分页
  @changeLoading(['is_loading'])
  async handleChange(data: any) {
    await this.getStyleList({
      current: data.current,
    });
  }

  // 更改排序
  @changeLoading(['is_loading'])
  async changeSort(record: any) {
    const res = await this.$axios.put(`${API.edit}${record.id}`, {
      id: record.id,
      sort: record.sort,
    });
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.active_index = -1;
    await this.getStyleList();
  }
  // 新增或编辑风格
  @changeLoading(['is_loading'])
  async addStyle() {
    if (!this.add_style_name) {
      this.$message.error('请输入风格名称');
      return;
    }
    let res;
    if (this.is_edit) {
      res = await this.$axios.put(`${API.edit}${this.edit_style_id}`, {
        id: this.edit_style_id,
        name: this.add_style_name,
      });
    } else {
      res = await this.$axios.post(API.add_style, {
        name: this.add_style_name,
      });
    }
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.is_edit = false;
    this.closeModal();
    await this.getStyleList();
  }

  @changeLoading(['is_loading'])
  async changeStatus(record: any) {
    if (record.is_show === 2) {
      const res = await this.$axios.put(`${API.edit}${record.id}`, {
        id: record.id,
        is_show: 1,
      });
      if (res.data.status !== 200) {
        this.$message.error(res.data.message);
        return;
      }
    } else {
      this.$confirm({
        title: '',
        content: '下架后小程序上将不会显示该风格及所属该风格的案例，确认下架？',
        icon: 'null',
        onOk: async () => {
          const res = await this.$axios.put(`${API.edit}${record.id}`, {
            id: record.id,
            is_show: 2,
          });
          if (res.data.status !== 200) {
            this.$message.error(res.data.message);
            return;
          }
          await this.getStyleList();
        },
      });
    }
    await this.getStyleList();
  }

  // 获取风格列表
  @changeLoading(['is_loading'])
  async getStyleList(
    query_params: any = {
      current: 1,
    }
  ) {
    const url = getUrl(API.get_list, query_params);
    const res = await this.$axios.get(url);
    if (res.data.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.style_list = initStyleList(res.data.data);
  }

  @changeLoading(['is_loading'])
  async created() {
    await this.getStyleList();
  }
}
